import axios from 'axios';
import * as Config from '../../config';

const state = {
    packages: {},
    package: {},
};

const actions = {

    load_Packages({ commit, dispatch }) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'package/list/all')
                .then(
                    response => {
                        //commit('LOAD_PACKAGES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_PackagesByField({ commit, dispatch },form) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'package/list/all/'+form.type+'/'+form.active)
                .then(
                    response => {
                        //commit('LOAD_PACKAGES',response.data)
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    load_Package({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'package/consult/' + form.id)
                .then(
                    response => {
                        //commit('LOAD_PACKAGE', data);
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });

    },
    new_Package({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'package/store', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeActive_Package({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'package/change/active/' + form.id + '/' + form.active)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    changeStatus_Package({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'package/change/status/' + form.id + '/' + form.status)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    update_Package({ commit, dispatch }, form) {

        return new Promise((resolve, reject) => {
            axios.put(Config.apiPath + 'package/update/' + form.id, form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    }
};

const mutations = {

    LOAD_PACKAGES(state, data) {
        state.packages = data;
    },
    LOAD_PACKAGE(state, data) {
        state.package = data;
    },

};

export default {
    state,
    actions,
    mutations
};